import { Box, Typography } from "@mui/material";

import { MAIN_BLUE } from "features/Influencer/PitchPlease/styles";

const styles = {
  header: { color: MAIN_BLUE, fontSize: 30 },
};

const PlanDetailsOOO = () => {
  return (
    <Box sx={{ my: 2 }}>
      {" "}
      <Typography
        variant="h2"
        sx={styles.header}
        textAlign="center"
        component="div"
      >
        <strong>
          Out-of-Office Club{" "}
          <Box
            component="span"
            sx={{ color: "#f6adaa", fontSize: 20, my: "-20px", opacity: 0.5 }}
          >
            x
          </Box>{" "}
          Bento
        </strong>
      </Typography>
      <Typography sx={{ my: 3 }}>
        Get all of your pitching needs done for you with Bento's AI and gain
        access to OOO Labs + workshops + in one bundled plan below.
      </Typography>
      <strong>Yearly Plan</strong>
    </Box>
  );
};

export default PlanDetailsOOO;
